/**
 * Utilitários para etiquetas de código de barras (EAN-13 / fallback).
 */

/**
 * Calcula o dígito verificador EAN (GS1): da direita para a esquerda, pesos 3,1,3,1…
 * @param {string} digits - apenas dígitos, sem o DV (12 para EAN-13, 7 para EAN-8)
 */
export function calcEanCheckDigit(digits) {
  const nums = String(digits).replace(/\D/g, '');
  let sum = 0;
  for (let i = 0; i < nums.length; i++) {
    const n = parseInt(nums[nums.length - 1 - i], 10);
    sum += i % 2 === 0 ? n * 3 : n;
  }
  return (10 - (sum % 10)) % 10;
}

/**
 * @param {string} value
 * @returns {{ format: 'EAN13' | 'EAN8' | 'CODE128', value: string } | null}
 */
export function resolveBarcodeFormat(value) {
  if (value == null) return null;
  const raw = String(value).trim();
  if (!raw) return null;

  const digits = raw.replace(/\D/g, '');

  if (digits.length === 13 && /^\d{13}$/.test(digits)) {
    const expected = calcEanCheckDigit(digits.slice(0, 12));
    if (expected === parseInt(digits[12], 10)) {
      return { format: 'EAN13', value: digits };
    }
  }

  if (digits.length === 8 && /^\d{8}$/.test(digits)) {
    const expected = calcEanCheckDigit(digits.slice(0, 7));
    if (expected === parseInt(digits[7], 10)) {
      return { format: 'EAN8', value: digits };
    }
  }

  return { format: 'CODE128', value: raw };
}

export function getPrimaryReference(product) {
  const refs = product?.references;
  if (!Array.isArray(refs) || refs.length === 0) return null;
  const first = refs[0];
  if (typeof first === 'string') return first.trim() || null;
  if (first && typeof first.reference === 'string') return first.reference.trim() || null;
  return null;
}
